import { IonIcon } from '@ionic/react';
import { IonicButton } from 'ionic-ui';
import { pencil, trashBin } from 'ionicons/icons';
import React from 'react';

export function DirectorCard(props: {
  full_name?: string;
  email?: string;
  phone?: string;
  role?: 'director' | 'owner' | 'manager' | 'secretary';
  percentage_ownership?: number;
  nin?: string;
  bvn?: string;
  onRemove: () => void;
  onEdit: () => void;
}) {
  return (
    <div className="p-3 shadow-sm border border-border rounded-md bg-background space-y-4">
      <div>
        <div className="flex items-center gap-2">
          <p className="high-emphasis-text flex-1 capitalize font-semibold truncate">
            {props.full_name || 'Not Provided'}
          </p>
          <div className="flex items-center gap-1">
            <IonicButton
              size="xs"
              onClick={props.onEdit}
              className="button-with-icon"
              variant="outline"
            >
              <IonIcon icon={pencil} />
            </IonicButton>
            <IonicButton
              type="button"
              onClick={props.onRemove}
              size="xs"
              className="button-with-icon destructive-button"
            >
              <IonIcon icon={trashBin} />
            </IonicButton>
          </div>
        </div>
        <div className="flex items-center justify-between gap-2 mt-2">
          {props.role && (
            <small className="py-1 px-2 font-medium rounded-md uppercase border border-border medium-emphasis-text block w-fit">
              {props.role}
            </small>
          )}
          {Number(props.percentage_ownership) > 0 && (
            <small>{props.percentage_ownership}% Ownership</small>
          )}
        </div>
      </div>
      <div className="space-y-2 medium-emphasis-text">
        <small className="truncate font-medium block">
          Email:{' '}
          <span className="high-emphasis-text ">
            {props.email || 'Not Provided'}
          </span>
        </small>
        <small className="truncate font-medium block">
          Phone No:{' '}
          <span className="high-emphasis-text">
            {props.phone || 'Not Provided'}
          </span>
        </small>
        <div className="space-x-2 flex items-center gap-2">
          {props.bvn && (
            <small className="block min-w-fit">
              BVN:{' '}
              <span className="high-emphasis-text font-medium">
                {props.bvn}
              </span>
            </small>
          )}
          {props.nin && (
            <small className="block min-w-fit">
              NIN:{' '}
              <span className="high-emphasis-text font-medium">
                {props.nin}
              </span>
            </small>
          )}
        </div>
      </div>
    </div>
  );
}
